import { z } from "zod";

export const enquirySchema = z.object({
  name: z.string().trim().min(2, "Please enter your name").max(80),
  phone: z.string().trim().regex(/^(\+234|0)\d{10}$/, "Use a Nigerian number, e.g. 07062025462"),
  message: z.string().trim().min(10, "Tell us a little more").max(1000),
  consent: z.literal(true, { error: "Please confirm we may contact you about this enquiry" })
});

export type Enquiry = z.infer<typeof enquirySchema>;
